import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OthersDialogComponent } from './others-dialog.component';
import { MatFormFieldModule } from "@angular/material/form-field";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from "src/app/shared/material/material.module";



@NgModule({
  declarations: [
    OthersDialogComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
],
  exports:[
    OthersDialogComponent
  ]
})
export class OthersDialogModule { }
